import { render, staticRenderFns } from "./Widget.vue?vue&type=template&id=32e52f72&scoped=true"
import script from "./Widget.vue?vue&type=script&lang=ts"
export * from "./Widget.vue?vue&type=script&lang=ts"
import style0 from "./Widget.vue?vue&type=style&index=0&id=32e52f72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e52f72",
  null
  
)

export default component.exports